import OutputChoose from './outputStorageChoose';
import { fetchFiles } from '../Utility/Storage/storageUtilsVizit';
import { retrieveMineData } from '../Utility/ConsumeToken/consumeToken';
import { getFileVizit } from '../Utility/ManageFiles/fileUtils';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';



const sortByDateDesc = (arr) =>
  [...arr].sort((a, b) => {
    const ta = a?.date ? new Date(a.date).getTime() : 0;
    const tb = b?.date ? new Date(b.date).getTime() : 0;
    return tb - ta;
  });
  
const VizitStorageLoader = ({
  buttonLabel = 'Upload from Vizit Storage',
  buttonClassName = 'sign-button button download-button',
  textAction = 'Use in Graph',
  popupMaxWidth = 1000,
  onLoad, // (parsedData) => void
  isAdmin = false,
}) => {
  const [showStorageModal, setShowStorageModal] = useState(false);
  const [storageFiles, setStorageFiles] = useState([]);
  const [isLoadingStorage, setIsLoadingStorage] = useState(false);

  const openStorageModal = async () => {
    try {
      setIsLoadingStorage(true);
      setShowStorageModal(true);

      const apitoken = await retrieveMineData();
      const fileList = await fetchFiles(apitoken._id, 'VIZITFS');

      const files =
        Array.isArray(fileList) ? fileList
        : Array.isArray(fileList?.files) ? fileList.files
        : Array.isArray(fileList?.data) ? fileList.data
        : [];

      const normalized = files.map(f => ({
        ...f,
        filename: f.filename ?? f.name ?? f.fileName,
        date: f.date ?? f.updatedAt ?? f.timestamp ?? f.lastModified ?? null,
      }));

      setStorageFiles(sortByDateDesc(normalized));
    } catch (err) {
      console.error('Error loading files from Vizit Storage:', err);
      setStorageFiles([]);
    } finally {
      setIsLoadingStorage(false);
    }
  };

  useEffect(() => {
  (async () => {
    await openStorageModal();
  })();
}, []);

  const handleChooseFile = async (fileName) => {
    try {
      setIsLoadingStorage(true);
      const apitoken = await retrieveMineData();
      const fileData = await getFileVizit('VIZITFS', fileName, apitoken);

      let parsed;
      try {
        parsed = JSON.parse(fileData.output);
      } catch {
        parsed = fileData.output;
      }

      setShowStorageModal(false);

      if (onLoad) {
        onLoad(parsed);
      }
    } catch (error) {
      console.error('Error to load file:', error);
    } finally {
      setIsLoadingStorage(false);
    }
  };

if( isAdmin ) {
  return (
    <>
          <div
            className="popup-content-output-admin"
            style={{
              maxWidth: popupMaxWidth
            }}
          >
            <p className="text" style={{ textAlign: 'center' }}>
              Choose a file from Vizit Storage to load into Graph
            </p>
            <div className="space"></div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 2px',
              }}
            >
              <span className="textlink">
                Files:{' '}
                <b>{Array.isArray(storageFiles) ? storageFiles.length : 0}</b>
              </span>
              <span className="text" style={{ opacity: 0.7 }}>
                {isLoadingStorage ? 'Loading…' : ' '}
              </span>
            </div>

            <div
              style={{
                flex: '1 1 auto',
                minHeight: 0,
                overflowY: 'auto',
                overflowX: 'hidden',
                border: '1px solid #e5e7eb',
                borderRadius: 5,
                padding: 7,
                margin: '0 5px',
                background: '#fff',
              }}
            >
              {isLoadingStorage ? (
                <p>Loading...</p>
              ) : Array.isArray(storageFiles) && storageFiles.length > 0 ? (
                sortByDateDesc(storageFiles).map((fileItem, idx) => (
                  <OutputChoose
                    key={`${fileItem.filename}-${idx}`}
                    name={fileItem.filename}
                    date={fileItem.date}
                    textAction={textAction}
                    action={() => handleChooseFile(fileItem.filename)}
                  />
                ))
              ) : (
                <p>Files not found</p>
              )}
            </div>
            <div className="riga" style={{margin: '15px 0 8px 0'}}>
              <Link className="textlink textLinkSign" to="/dashboard">
                Back to Dashboard <FaArrowRight size={12} style={{ marginLeft: '8px', marginBottom: '-1px' }} />
              </Link>
            </div>    
          </div>
    </>
  )} else {
  return (
    <>
          <div
            className="popup-content-output"
            style={{
              maxWidth: popupMaxWidth
            }}
          >
            <p className="text" style={{ textAlign: 'center' }}>
              Choose a file from Vizit Storage to load into Graph
            </p>
            <div className="space"></div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 2px',
              }}
            >
              <span className="textlink">
                Files:{' '}
                <b>{Array.isArray(storageFiles) ? storageFiles.length : 0}</b>
              </span>
              <span className="text" style={{ opacity: 0.7 }}>
                {isLoadingStorage ? 'Loading…' : ' '}
              </span>
            </div>

            <div
              style={{
                flex: '1 1 auto',
                minHeight: 0,
                overflowY: 'auto',
                overflowX: 'hidden',
                border: '1px solid #e5e7eb',
                borderRadius: 5,
                padding: 7,
                margin: '0 5px',
                background: '#fff',
              }}
            >
              {isLoadingStorage ? (
                <p>Loading...</p>
              ) : Array.isArray(storageFiles) && storageFiles.length > 0 ? (
                sortByDateDesc(storageFiles).map((fileItem, idx) => (
                  <OutputChoose
                    key={`${fileItem.filename}-${idx}`}
                    name={fileItem.filename}
                    date={fileItem.date}
                    textAction={textAction}
                    action={() => handleChooseFile(fileItem.filename)}
                  />
                ))
              ) : (
                <p>Files not found</p>
              )}
            </div>
            <div className="riga" style={{margin: '15px 0 8px 0'}}>
              <Link className="textlink textLinkSign" to="/dashboard">
                Back to Dashboard <FaArrowRight size={12} style={{ marginLeft: '8px', marginBottom: '-1px' }} />
              </Link>
            </div>    
          </div>
    </>
  )};
};

export default VizitStorageLoader;
